import { ThankYouPageState } from './ThankYouPageTypes';

export const ThankYouPageActionTypes = {
  LOAD_THANK_YOU_PAGES: 'loadThankYouPages',
  LOADED_THANK_YOU_PAGES: 'loadedThankYouPages',
  LOAD_THANK_YOU_PAGES_ERROR: 'loadThankYouPagesError',

  LOAD_FORM_VALUES: 'loadFormValues',
};

export const DEFAULT_STATE: ThankYouPageState = {
  thankYouPagesMap: [],
  reloadThankYouPagesMap: false,
  formValues: {
    BuyerGroupName: '',
    ThankYouPageUrl: '',
  },
};
